module.exports = __webpack_public_path__ + "static/media/SF_bm_primaerlogo_vestland_neg.09dea6fc.svg";